import AcquireTokenCallback from '../schema/AcquireTokenCallback';
import AuthenticationContext from 'adal-angular';

export default function acquireTokenFromAuthContext(
    authContext: AuthenticationContext,
    resource: string,
    authChallenge: string,
    getAccessTokenCallback: AcquireTokenCallback
): void {
    if (authChallenge) {
        authContext.acquireTokenPopup(
            resource,
            null /* extraParameters */,
            authChallenge,
            getAccessTokenCallback
        );
    } else {
        authContext.acquireToken(resource, getAccessTokenCallback);
    }
}
